/**
 * Public client IDs for social login (never secrets — those live on the backend).
 * Fill these in per environment, or leave empty to hide/disable a provider.
 *
 * - Facebook / GitHub / LinkedIn / Microsoft use a dependency-free WebView
 *   authorization-code flow (`SOCIAL_CLIENT_IDS`).
 * - Google uses the system browser via `expo-auth-session` — supply the per-
 *   platform OAuth client IDs in `GOOGLE_NATIVE_CLIENT_IDS`.
 * - Apple uses the native `expo-apple-authentication` sheet (Face ID / Touch ID)
 *   on iOS (keyed by the app's bundle id — no client id needed there). On
 *   ANDROID, where no native Apple SDK exists, it falls back to the same WebView
 *   authorization-code flow using the Apple **Services ID** below (must be
 *   registered on the Apple Developer portal with the backend
 *   `/auth/apple/callback` return URL; the backend exchanges the code).
 *
 * See the backend docs/SOCIAL_LOGIN_PROVIDER_SETUP.md.
 */
export const SOCIAL_CLIENT_IDS = {
    facebook: '565823282075831',
    github: 'Ov23li8d46HwnQRFHG1x',
    linkedin: '77nupbsidfyxzd',
    microsoft: 'e79c8abe-eab0-41b1-804d-26d763f7f384',
    // Apple Services ID (web/Android WebView flow) — accepted as the id_token
    // `aud` by the backend (APPLE_DEFAULT_CLIENT_IDS). iOS ignores this and uses
    // the native sheet keyed by the bundle id.
    apple: 'hu.happysolutions.app.web',
};

/**
 * Google OAuth client IDs, one per platform (create them in Google Cloud Console
 * as iOS / Android / Web OAuth clients). `expo-auth-session` picks the right one.
 *
 * NOTE: `web` MUST be the LOGIN client (the one the backend accepts as the
 * id_token `aud` via GOOGLE_CLIENT_ID / GOOGLE_CLIENT_IDS) — not the Calendar
 * client — or Google sign-in fails the backend audience check.
 */
export const GOOGLE_NATIVE_CLIENT_IDS = {
    // iOS client (bundle hu.happysolutions.app), same GCP project as the web client.
    ios: '806425959155-7u17khnttgtggpastss2j6okhj21p0ep.apps.googleusercontent.com',
    // Android client (package org.happysolutions.app), same GCP project as the web client.
    android: '806425959155-1voo6athi0ea2jb73o0nbalug1bre2i1.apps.googleusercontent.com',
    // Web client id — the "Happy App" login client (backend GOOGLE_CLIENT_ID).
    web: '806425959155-4ck17ra1smljb24pqf8ro3jmgh9rls59.apps.googleusercontent.com',
};

export default SOCIAL_CLIENT_IDS;
